// Design tokens extracted into .stitch/DESIGN.md. Keep in sync with the
// --color-primary* variables in src/index.css.
export const colors = {
    primary: '#2563eb',
    primaryHover: '#1d4ed8',
    primaryLight: '#60a5fa',
    success: '#16a34a',
    error: '#dc2626',
    warning: '#f2a900',
    textHeading: '#162033',
    text: '#344054',
    textSecondary: '#667085',
    borderSecondary: '#e2e8f0',
    bgLayout: '#f8fafc',
};

const antdTheme = {
    token: {
        colorPrimary: colors.primary,
        colorInfo: colors.primary,
        colorLink: colors.primary,
        colorLinkHover: colors.primaryHover,
        colorSuccess: colors.success,
        colorError: colors.error,
        colorWarning: colors.warning,
        colorTextHeading: colors.textHeading,
        colorText: colors.text,
        colorTextSecondary: colors.textSecondary,
        colorBorderSecondary: colors.borderSecondary,
        colorBgLayout: colors.bgLayout,
        fontFamily: "'Nunito Sans', sans-serif",
        borderRadius: 8,
    },
};

export default antdTheme;
